import appConfig from "../../config/app_config"; // Retrives the original config information from the web
import { store } from "../store.js"; // Uses the library to store or retrieve generic data

// Parameter 'onEventCallBack'          : Stores the Data from the account, Name of the used function(optional), Source, SourceState, SourceType and a TimeStamp
// Parameter 'sessionId'                : The ID from the session
// Parameter 'token'                    : The token from the session
// Parameter 'signals'                  : When socket is created threw a creation of a quadrant, it will store the signals
// Parameter 'onConnectionStatus'       : Checks the status of the connection
// Extra Parameter 'requestTable'       : Sets an object which contains data about the request
// Extra Parameter 'timer'              : Sets the timer for the time-out
// Extra Parameter 'afterStartCallBack' : The callback after the function 'start'
// Extra Parameter 'createArgs()'       : Function to set the 'this.args' which includes a 'securityToken' and a 'sessionId'
// Extra Parameter 'requestId'          : The ID from the amount of requests that has been made for a socket


/*--
Creating the socket for a web-user, which can be done on 2 sections:
- After the user has logged in this will create a web socket with the preferences of the account
- After creating a quadrant in the 'operationalScreen' tab this will create a web socket containging the data and position from the quadrant
--*/
export default class SocketClient {
   constructor(onEventCallback, sessionId, token, signals, onConnectionStatus = null) {
    this.onEventCallback = onEventCallback;
    this.sessionId = sessionId;
    this.token = token;
    this.signals = signals;
    this.onConnectionStatus = onConnectionStatus;
    this.requestTable = {};
    this.timer = "";
    this.afterStartCallback = null;
    this.createArgs();
    this.requestId = 0;
   }
  // Function to set the 'args' parameter with the token and sessionId
  createArgs() {
    this.args = {
      securityToken: this.token,
      sessionId: this.sessionId
    };
  }
  // This is called whenever a socketClient is needed to start (called on 'OperationalScreen_BaseQuadrant' and on 'Websocket_helper')
  start(cb = null) {
    if (cb != null) {
      this.afterStartCallback = cb;
    }
    // If websocket (this.ws) does not exist, create one and set the data
    if (!this.ws) {
      try {
        this.ws = new WebSocket(appConfig.webSession.url);

        this.ws.onmessage = this.message.bind(this);
        this.ws.onerror = this.error.bind(this);
        this.ws.onclose = this.onclose.bind(this);
        this.ws.onopen = () => {
          window.EventBus.fire('disableErrorSnackBar', 'No error');
          let message = this.createRegisterSessionRequest();
          this.sendMessage(message, () => {
            setTimeout(() => {
              this.afterStartCallback();
            }, 100);
          });
        };
      } catch (e) {
        console.error('RESTART TIMEOUT Error in socket creation e', e);
      }
    } else {
      console.error("start WS NULL");
    }
  }
  // This is called whenever a socketClient is needed to stop (called on 'OperationalScreen_BaseQuadrant' and on 'Websocket_helper')
  stop(removeListener = false) {
    if (this.ws) {
      clearTimeout(this.timer);
      if(removeListener){
        // Sets all the data from the socket to 'undefined'
        this.ws.onclose = undefined;
        this.ws.onerror = undefined;
        this.ws.onmessage = undefined;
        this.ws.onopen = undefined;
      }
      console.log("trying to stop ws", this.ws);
      if (this.ws.readyState != this.ws.CLOSED) {
        this.ws.close();
      }
      this.ws = null;
    } else {
      console.warn('Socket stop ws', this.ws);
    }
    // Clears the 'requestTable'
    this.requestTable = {};
  }
  // Whenever the 'error' function is recieved, it prints the error
  error(msg) {
    console.error("Error in socket communication", msg, this.sessionId);
  }

  // whenever this is recieved, the web closes the socket connection and restart the timer
  onclose(event) {
    console.log("close socket connection", event, this.sessionId);
    this.restartTimeout();
  }

  // Whenever the socket uses the function 'message' it redirects to the function handleDssMg and parses this as JSON
  message(msg) {
    this.handleDSSmsg(JSON.parse(msg.data));
  }
  // This function sends an alive message with a counter(++) on the requestId
  sendAlive() {
    let message = {
      alive: {
       RequestId: this.requestId++
      }
    };
    // sends the message in JSON to the webSocket
    this.ws.send(JSON.stringify(message));
    }

   // Socket can use this function the send a message to the user of the webSocket
  sendMessage(data, callback, error_callback, pending_callback) {
    if (typeof callback == "undefined") {
      //TODO use generic callback
      callback = () => {
        return true;
      };
    }

    if (typeof error_callback == "undefined") {
      //TODO use generic callback
      error_callback = obj => {
        console.error("error obj.replyMessage.value", obj);
        return true;
      };
    }

    if (typeof pending_callback == "undefined") {
      pending_callback = () => {
        return true;
      };
    }

    if (typeof data == "object") {
      let request = {};
      this.findRequestId(data, request);

      if (typeof data.alive != "undefined") {
        //alives should not be in the request table as there will be no response
      } else {
        this.requestTable[String(request.id)] = {
          callback: callback,
          error_callback: error_callback,
          pending_callback: pending_callback,
          timeout: setTimeout(() => {
            this.checkReply(String(request.id), data);
          }, 15000) //request time-out
        };
      }
      data = JSON.stringify(data);
    }
    try {
      this.ws.send(data);
    } catch (err) {
      console.log("ERROR " + err);
    }
  }

  checkReply(id, data) {
    var obj = JSON.parse(data);
    //TODO it needs to remove the callback from this.requestTable !!!
  }

  //This is called to find the requestId
  findRequestId(object, request) {
    //requestId = object.request.requestId.value;
    if (object && typeof object == "object") {
      for (const [key, value] of Object.entries(object)) {
        if (key == "requestId") {
          request.id = value.value;
          return true;
        } else {
          if (typeof value == "object") {
            this.findRequestId(value, request);
          }
        }
      }
    }
  }
 // dedicated session for registering
  createRegisterSessionRequest() {
    const request = {
      registerSession: {
        requestId: this.requestId++,
        securityToken: store.getters['auth/token'],
        ...this.args,
        "linkAndConnect": {
        }
      }
    };
    if (this.signals !== undefined) {
    this.signals.forEach((element, key) => {
      request.registerSession.linkAndConnect[key] = {};
      element.forEach((e, i) => {
        request.registerSession.linkAndConnect[key]['sig'+i] = e[0];
      })
    });
  }
/**
        signalsList.forEach((signal, index) => {
          request.signals["sig" + index] = signal[0];
          // {
          // datatype: "string",
          // value: signal[0]
          // };
        });
 *
 */

    return request;
  }

  // restarts the timer
  restartTimeout() {
    if (this.timer !== "") {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      console.log("timeout on socket " + 600000 + " ms have passed");
      this.reconnect();
    }, 600000); //alive time-out
  }

  // function to handle the message from the socket (in JSON data)
  handleDSSmsg(data) {
    this.restartTimeout();

    var key = Object.keys(data);
    if (key.length > 1) {
      window.log.debug(
        2,
        "received more than 1 container in reply unable to handle this as of now"
      );
    }

    switch (key[0]) {
      case "reply":
        //check if the reply was succesfull
        if (data.reply.returnValue.value == 0) {
          // console.warn(data);

          console.log('clearing timeout... 1', data.reply.requestId);
          console.log('clearing timeout... 2', this.requestTable);
          console.log('clearing timeout... 3', data, this.requestTable[String(data.reply.requestId.value)]);
          clearTimeout(
            this.requestTable[String(data.reply.requestId.value)].timeout
          );
          this.requestTable[String(data.reply.requestId.value)].error_callback(
            data.reply
          );
          delete this.requestTable[String(data.reply.requestId.value)];
        } else if (data.reply.returnValue.value == -1) {
          // pending
          if (typeof data.reply.requestId != undefined) {
            if (
              typeof this.requestTable[String(data.reply.requestId.value)] !=
              "undefined"
            ) {
              data.reply.retdata.pendingFlag = true;
              clearTimeout(
                this.requestTable[String(data.reply.requestId.value)].timeout
              );
              this.requestTable[
                String(data.reply.requestId.value)
              ].pending_callback(data.reply.retdata);
            } else {
            }
          }
        } else {
          if (typeof data.reply.requestId != undefined) {
            if (
              typeof this.requestTable[String(data.reply.requestId.value)] !=
              "undefined"
            ) {
              clearTimeout(
                this.requestTable[String(data.reply.requestId.value)].timeout
              );
              let obj = this.requestTable[String(data.reply.requestId.value)];
              if (obj.hasOwnProperty("callback")) {
                obj.callback(data.reply.retdata);
              }
              if (obj.hasOwnProperty("promise")) {
                obj.promise.then(data.reply.retdata);
              }
              //removing the request from the request table
              delete this.requestTable[String(data.reply.requestId.value)];
            } else {
              window.log.debug(5, this.requestTable);
            }
          }
        }
        break;
      case "alive":
      case "Alive":
        this.sendAlive();
        //restarting the alive is done for all incoming messages
        break;

      case "event":
      case "Event":
        this.eventHandler(data.Event);
        break;
      default:
        break;
    }
  }
 // function can be called to reconnect the web-socket, stops the socket and starts the socket
  reconnect() {
    console.error("GOING TO RECONNECT", this.args);

    clearInterval(""); // Clears the interval - standard method by JavaScript
    this.stop();
    if (this.onConnectionStatus !== null) {
      let sId = this.onConnectionStatus(null);
      console.error("reconnect sessionid ", this.sessionId, sId);
      this.sessionId = sId;
      this.createArgs();
      console.error("GOING TO RECONNECT", this.args);
    }

    this.start();
  }

  // When this is called the parameter for the constructor 'onEventCallback' sets new data
  eventHandler(event) {
    this.onEventCallback(event);
  }

}
